import { render } from "./SubmitSummaryClaimComponent.vue?vue&type=template&id=6f44d005&scoped=true"
import script from "./SubmitSummaryClaimComponent.vue?vue&type=script&lang=js"
export * from "./SubmitSummaryClaimComponent.vue?vue&type=script&lang=js"

import "./SubmitSummaryClaimComponent.vue?vue&type=style&index=0&id=6f44d005&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f44d005"]])

export default __exports__